export default [
    {
        title: 'Test naslov',
        src: '/gallery/mostici/1.jpg',
        thumbnail: '/gallery/thumbnail/1.jpg',
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/4.jpg',
        thumbnail: '/gallery/thumbnail/4.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/5.jpg',
        thumbnail: '/gallery/thumbnail/5.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/7.jpg',
        thumbnail: '/gallery/thumbnail/7.jpg',
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/9.jpg',
        thumbnail: '/gallery/thumbnail/9.jpg'

    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/12.jpg',
        thumbnail: '/gallery/thumbnail/12.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/14.jpg',
        thumbnail: '/gallery/thumbnail/14.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/17.jpg',
        thumbnail: '/gallery/thumbnail/17.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/18.jpg',
        thumbnail: '/gallery/thumbnail/18.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/19.jpg',
        thumbnail: '/gallery/thumbnail/19.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/20.jpg',
        thumbnail: '/gallery/thumbnail/20.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/21.jpg',
        thumbnail: '/gallery/thumbnail/21.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/22.jpg',
        thumbnail: '/gallery/thumbnail/22.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/23.jpg',
        thumbnail: '/gallery/thumbnail/23.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/24.jpg',
        thumbnail: '/gallery/thumbnail/24.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/25.jpg',
        thumbnail: '/gallery/thumbnail/25.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/26.jpg',
        thumbnail: '/gallery/thumbnail/26.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/27.jpg',
        thumbnail: '/gallery/thumbnail/27.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/28.jpg',
        thumbnail: '/gallery/thumbnail/28.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/29.jpg',
        thumbnail: '/gallery/thumbnail/29.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/30.jpg',
        thumbnail: '/gallery/thumbnail/30.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/31.jpg',
        thumbnail: '/gallery/thumbnail/31.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/32.jpg',
        thumbnail: '/gallery/thumbnail/32.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/33.jpg',
        thumbnail: '/gallery/thumbnail/33.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/34.jpg',
        thumbnail: '/gallery/thumbnail/34.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/35.jpg',
        thumbnail: '/gallery/thumbnail/35.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/36.jpg',
        thumbnail: '/gallery/thumbnail/36.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/37.jpg',
        thumbnail: '/gallery/thumbnail/37.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/38.jpg',
        thumbnail: '/gallery/thumbnail/38.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/39.jpg',
        thumbnail: '/gallery/thumbnail/39.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/40.jpg',
        thumbnail: '/gallery/thumbnail/40.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/41.jpg',
        thumbnail: '/gallery/thumbnail/41.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/42.jpg',
        thumbnail: '/gallery/thumbnail/42.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/43.jpg',
        thumbnail: '/gallery/thumbnail/43.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/44.jpg',
        thumbnail: '/gallery/thumbnail/44.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/45.jpg',
        thumbnail: '/gallery/thumbnail/45.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/46.jpg',
        thumbnail: '/gallery/thumbnail/46.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/47.jpg',
        thumbnail: '/gallery/thumbnail/47.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/48.jpg',
        thumbnail: '/gallery/thumbnail/48.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/49.jpg',
        thumbnail: '/gallery/thumbnail/49.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/50.jpg',
        thumbnail: '/gallery/thumbnail/50.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/51.jpg',
        thumbnail: '/gallery/thumbnail/51.jpg'
    },
    {
        title: 'Test naslov',
        src: '/gallery/mostici/52.jpg',
        thumbnail: '/gallery/thumbnail/52.jpg'
    }
];